export const RECEIVE_COLOR = 'RECEIVE_COLOR';
